<div class="container">
  <ng-container *ngIf="liabilitiesLoading; else emptyState">
    <div class="biller-loader">
      <div class="biller-loader__content">
        <ng-container *ngIf="customerBiller; else noBiller">
          <div class="flex flex-col items-center">
            <app-biller-logo [billerCode]="customerBiller.biller.code"
                             size="50"
                             [size]="50"
            ></app-biller-logo>
            <div class="title">{{ customerBiller.biller.name }}</div>
          </div>

          <div class="progress" *ngIf="progressBarVisible">
            <div class="progress__value">{{ fakeProgress.loaderValue$ | async }}%</div>
            <mat-progress-bar
              class="progress__bar"
              [value]="fakeProgress.loaderValue$ | async"
              [mode]="(fakeProgress.loaderValue$ | async) ? 'determinate' : 'indeterminate'"
            ></mat-progress-bar>
          </div>

          <p class="description" *ngIf="customerBiller.status === CustomerBillerStatus.VERIFYING">
            Trwa weryfikacja danych dostępowych. Może to potrwać kilka minut.
          </p>

          <p class="description" *ngIf="customerBiller.status === CustomerBillerStatus.CONFIRMED">
            Połączenie aktywne. Trwa pobieranie opłat, może to potrwać kilka minut.
          </p>
        </ng-container>
        <ng-template #noBiller>
          <div class="progress" *ngIf="progressBarVisible">
            <mat-progress-bar class="progress__bar" [value]="fakeProgress.loaderValue$ | async" mode="indeterminate">
            </mat-progress-bar>
          </div>
          <p class="description">Trwa ładowanie dostawcy.</p>
        </ng-template>
      </div>
    </div>
  </ng-container>

  <ng-template #emptyState>
    <img src="/assets/images/cart.svg" alt="Pusty koszyk" />
    <div class="title">Twój koszyk jest pusty</div>
    <p class="description">Dodaj dostawcę, aby pobrać opłaty.</p>
    <div class="mb-16">
      <button mat-stroked-button color="primary" (click)="addBiller()">Dodaj dostawcę</button>
    </div>
    <div>
      <button mat-stroked-button color="primary" (click)="addLiability()">Dodaj opłatę</button>
    </div>
  </ng-template>
</div>
